module.exports = __webpack_public_path__ + "img/4.a907efc3.jpg";